import Vue from 'vue';
import Vuex from 'vuex';

import game from './modules/game';
import entry from './modules/entry';

Vue.use( Vuex );
require( 'es6-promise' ).polyfill();

export default new Vuex.Store({
    strict: true,

    modules: {
        game,
        entry
    },

    state: {

    },

    getters: {

    },

    mutations: {

    },

    actions: {

    }
});
